import * as Yup from 'yup';
import RSInput from './ValidationSchema/RSInput';
import RSPhone from './ValidationSchema/RSPhone';
import RSEmail from './ValidationSchema/RSEmail';
import RSMulti from './ValidationSchema/RSMulti';
import RSSelect from './ValidationSchema/RSSelect';


const RSValidation = (sections) => {
  const devNull = (qObj) => {
//    console.log('no validation' +qObj.question_type);
  };
  const qTypes = {
    hidden: devNull,
    display:devNull,
    text: RSInput,
    phone: RSPhone,
    file: devNull,
    email: RSEmail,
    currency: devNull,
    textarea: devNull,
    textarea_video: devNull,
    video_upload: devNull,
    number: devNull,
    radio: devNull,
    checkboxes: RSMulti,
    select: RSSelect,
    bullets: devNull,
    numberlist: devNull,
    multiselect: RSMulti,

    optionSelect: devNull,
    industries: devNull,
    industries_and_aliases: devNull,
    expertise: RSMulti,
    computerskills: RSMulti,
    docupilot: devNull,
    multipart: devNull,
    multipart_revenue: devNull,
    ai: devNull,

  };
  const validationObj = {};
  if(sections) {
    const questions = sections.questions || [];
    questions.map((qObj) => {
      if (typeof qObj.question_type !== 'undefined') {
        validationObj[qObj.qid] = qTypes[qObj.question_type]({ qObj });
      }
      return validationObj;
    });
    if (typeof sections.question_parts !== 'undefined') {
      sections.question_parts.map((qObj) => {
        if (typeof qObj.question_type !== 'undefined') {
          const question_type = qObj.question_type;
          const qid = qObj.qid;
          validationObj[qid] = qTypes[question_type]({ qObj });
        }
        return validationObj;
      });
    }
    const validationSchema = Yup.object({
      jobSeekerData: Yup.array().of(
        Yup.object(validationObj),
      ),
    });
    return validationSchema;
  }
  return undefined;
};

export default RSValidation;
